import { Component } from 'react'
import { OnsetDateTime, Code, CodeableConcept } from '../helpers'
import { GiHypodermicTest } from 'react-icons/gi'

import './resource.css'

class Immunization extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isJson: false,
            css: false
        }
    }

    handleJson() {
        this.setState({ css: !this.state.css })
        setTimeout(() => this.setState({ isJson: !this.state.isJson }), 300)
    }

    handleSelect(id) {
        if (this.props.onSelect) this.props.onSelect(id)
    }

    render() {
        return <div className={`Flip-Container`} onClick={() => this.handleJson()}><div className={`Res-Container Res-Immunization${this.state.css ? ' Flip' : ''}`}>
            {this.state.isJson ? <div className='Res-Json'><pre>{JSON.stringify(this.props.resource, undefined, 2)}</pre></div> :
                <div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.status && 'Status'}</div>
                            <div className='Res-Title'>{this.props.resource.status && Code(this.props.resource.status)}</div>
                        </div>
                        <div className='Res-Icon-Big'><GiHypodermicTest /></div>
                        <div>
                            <div style={{textAlign: 'right'}} className='Res-Detail Res-Content-Rev'>{this.props.resource.statusReason && 'Reason'}</div>
                            <div className='Res-Title'>{this.props.resource.statusReason && CodeableConcept(this.props.resource.statusReason)}</div>
                        </div>
                    </div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.vaccineCode && 'Vaccine'}</div>
                            <div className='Res-Title'>{this.props.resource.vaccineCode && CodeableConcept(this.props.resource.vaccineCode)}</div>
                        </div>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.lotNumber && 'Lot'}</div>
                            <div className='Res-Title'>{this.props.resource.lotNumber && this.props.resource.lotNumber}</div>
                        </div>
                    </div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.site && 'Site'}</div>
                            <div className='Res-Title'>{this.props.resource.site && CodeableConcept(this.props.resource.site)}</div>
                        </div>
                        <div>
                            <div style={{textAlign: 'right'}} className='Res-Detail Res-Content-Rev'>{this.props.resource.route && 'Route'}</div>
                            <div style={{textAlign: 'right'}} className='Res-Title'>{this.props.resource.route && CodeableConcept(this.props.resource.route)}</div>
                        </div>
                    </div>
                    {this.props.resource.expirationDate && <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>Expires</div>
                        <div className='Res-Title'>{OnsetDateTime(this.props.resource.expirationDate)}</div>
                    </div>}
                    
                </div>
            }
        </div></div>
    }
}

export default Immunization